import { useMutation } from '@tanstack/react-query';
import { deleteSmartList } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export type DeleteSmartListVariables = {
  uid: ID;
  smartListId: ID;
};

export const useDeleteSmartListMutation = () =>
  useMutation({
    mutationFn: ({ uid, smartListId }: DeleteSmartListVariables) =>
      deleteSmartList(uid, smartListId),
  });
